import { render, staticRenderFns } from "./PencilIcon.vue?vue&type=template&id=a4e97f16&"
import script from "./PencilIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PencilIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports